import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { getBaseUrl, INTERVIEW_LOCATIONS_ENDPOINT } from '../../constants';

export class InterviewLocations {
  static getInstance() {
    if (!this.instance) {
      this.instance = new InterviewLocations(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = INTERVIEW_LOCATIONS_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAllInterviewLocations(req) {
    const queryString = queryBuilder(req);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  }

  async postInterviewLocation(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }

  async putInterviewLocationById(req) {
    const url = `${this.base_url}${this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.putData(url, req.reqBody);
    return response?.data;
  }

  async deleteInterviewLocationById(req) {
    const url = `${this.base_url}${this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.deleteData(url, req.reqBody);
    return response;
  }
}

export const createInterviewLocations = () => InterviewLocations.getInstance();
